import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { AdminMaster } from '@shared/models/interfaces/adminMaster.interface';
import { Response } from '@shared/models/interfaces/response.interface';
import { HttpService } from '@shared/providers/http.service';

@Injectable({
  providedIn: 'root',
})
export class MasterAdminService extends HttpService {
  constructor(httpClient: HttpClient, store: Store) {
    super(environment.endpoints.adminsMaster, httpClient, store);
  }

  getAdminById(id: number): Promise<Response<{ masterAdmins: AdminMaster }>> {
    return this.getAsync<Response<{ masterAdmins: AdminMaster }>>(`/${id}`);
  }

  update(adminMaster: AdminMaster) {
    return this.putAsync(adminMaster, `/${adminMaster.user.userId}`);
  }
}
